import * as svg from "../../../assets/checked-circle-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CheckedCircleIcon = iconBuilder(svg, "CheckedCircleIcon", "0 0 48 49");
